import { createSelector, createSlice } from "@reduxjs/toolkit"
import { RootState } from "@/store"

import { IUser } from "@/types/user"

import { setToken, removeToken } from "@/hooks/useAuthStorage"

function resolveTenantUserKey(): string {
  if (typeof window === "undefined") return "user"
  const host = window.location.hostname.toLowerCase()
  const firstPath = window.location.pathname.replace(/^\/+/, "").split("/")[0]?.toLowerCase() || ""
  if (host.includes("claricel") || firstPath === "claricel") return "claricel:user"
  if (host.includes("nxum") || firstPath === "nxum") return "nxum:user"
  if (host.includes("infynit") || firstPath === "infynit") return "infynit:user"
  if (host.includes("pandamovil") || firstPath === "pandamovil" || firstPath === "panda") return "pandamovil:user"
  if (host.includes("celink") || firstPath === "celink") return "celink:user"
  return "user"
}

const getUser: () => IUser = () => {
  const raw = sessionStorage.getItem(resolveTenantUserKey())
  if (!raw || raw === "undefined") return null
  try {
    const parsed = JSON.parse(raw)
    if (!parsed || !Array.isArray(parsed.menu)) {
      sessionStorage.removeItem(resolveTenantUserKey())
      return null
    }
    return parsed
  } catch {
    sessionStorage.removeItem(resolveTenantUserKey())
    return null
  }
}

const getInitialState = () => {
  const user = getUser()
  return {
    user,
    isAuthenticated: !!user,
    error: "",
  }
}
const initialState = getInitialState()

type LoginPayload = { token: string }
type LoginAction = {
  type: string
  payload: LoginPayload
}

const UserSlice = createSlice({
  name: "UserSlice",
  initialState,
  reducers: {
    login: (state, action: LoginAction) => {
      state.isAuthenticated = true
      setToken(action.payload.token)
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.user = null
      sessionStorage.removeItem(resolveTenantUserKey())
      removeToken()
    },
    setUser: (state, action) => {
      state.isAuthenticated = true
      state.user = action.payload
      sessionStorage.setItem(resolveTenantUserKey(), JSON.stringify(action.payload))
    },
  },
})

export const { login, logout, setUser } = UserSlice.actions

export const userSelector = createSelector(
  (state: RootState) => state.User,
  (User) => User.user
)

export default UserSlice.reducer
